import './footer.css';
import React from 'react'

function Footer() {
  return (
    <footer className='footer-container'>website created with&nbsp;<span className='love-icon'>&#10084; </span>&nbsp;by&nbsp;<a href='https://mayanknasa.netlify.app/' target='__blank'> Mayank Nasa</a></footer>
  )
}

export default Footer
